// Mock data for Antologia SaaS Storefront

export const products = [
  {
    id: 'telephony',
    name: 'Облачная телефония',
    shortDescription: 'Виртуальная АТС для бизнеса с интеграцией CRM',
    fullDescription: 'Облачная телефония для бизнеса любого масштаба. Интеграция с популярными CRM-системами (Битрикс24, amoCRM, 1С), запись звонков, аналитика и отчётность. Без капитальных затрат, оплата по подписке.',
    category: 'communications',
    tags: ['CRM', 'Звонки', 'Аналитика'],
    icon: 'Phone',
    features: [
      'Виртуальные номера в 80+ регионах',
      'Запись и хранение разговоров',
      'Интеграция с CRM за 1 день',
      'Аналитика эффективности менеджеров',
      'IVR-меню и маршрутизация'
    ],
    situations: ['crm-deals', 'call-control'],
    price: 'от 5600 ₽/мес'
  },
  {
    id: 'omnichannel',
    name: 'Омниканальная платформа',
    shortDescription: 'Все коммуникации в одном окне',
    fullDescription: 'Объединяйте почту, звонки, SMS, мессенджеры и социальные сети в едином интерфейсе. История общения с клиентом всегда под рукой. Повышайте скорость обработки обращений и качество сервиса.',
    category: 'omnichannel',
    tags: ['Мессенджеры', 'Почта', 'SMS'],
    icon: 'MessageSquare',
    features: [
      'WhatsApp, Telegram, VK, Авито',
      'Единая история переписки',
      'Автоматическое распределение обращений',
      'Шаблоны быстрых ответов',
      'Мониторинг SLA'
    ],
    situations: ['integrate-channels', 'support-workload'],
    price: 'от 5900 ₽/мес'
  },
  {
    id: 'ai-agent',
    name: 'AI-агент',
    shortDescription: 'Умный ассистент для обработки обращений',
    fullDescription: 'AI-оператор на базе нейросетей. Обрабатывает типовые запросы, квалифицирует лиды, записывает на приём. Работает 24/7, не устаёт и не ошибается. Интеграция с базой знаний компании.',
    category: 'ai',
    tags: ['AI', 'Автоматизация', '24/7'],
    icon: 'Bot',
    features: [
      'Обработка до 80% типовых запросов',
      'Интеграция с базой знаний',
      'Передача сложных кейсов оператору',
      'Мультиязычная поддержка',
      'Обучение на данных компании'
    ],
    situations: ['support-workload', 'crm-deals'],
    price: 'от 150000 ₽/мес'
  },
  {
    id: 'call-analytics',
    name: 'Речевая аналитика',
    shortDescription: 'AI-анализ звонков и транскрибация',
    fullDescription: 'Автоматическая транскрибация звонков, анализ тональности, выявление ключевых слов. Контроль качества работы менеджеров, выявление проблемных зон в скриптах продаж.',
    category: 'analytics',
    tags: ['AI', 'Контроль', 'Скрипты'],
    icon: 'BarChart3',
    features: [
      'Распознавание речи 95%+ точности',
      'Анализ тональности разговора',
      'Автоматический чек-лист контроля',
      'Выявление стоп-слов',
      'Интеграция с CRM'
    ],
    situations: ['call-control', 'crm-deals'],
    price: 'от 9 490 ₽/мес'
  },
  {
    id: 'knowledge-base',
    name: 'Корпоративная база знаний',
    shortDescription: 'AI-поиск по документам компании',
    fullDescription: 'Создайте единую базу знаний с AI-поиском. Быстрые ответы для сотрудников и клиентов. Интеграция с внутренними системами, версионирование документов.',
    category: 'ai',
    tags: ['AI', 'Документы', 'Поиск'],
    icon: 'BookOpen',
    features: [
      'Семантический поиск по документам',
      'Автоматические ответы на вопросы',
      'Интеграция с 1С и Битрикс',
      'Контроль доступа',
      'Аналитика популярных запросов'
    ],
    situations: ['support-workload'],
    price: 'от 6900 ₽/мес'
  },
  {
    id: 'crm-integration',
    name: 'CRM-интеграции',
    shortDescription: 'Связываем ваши системы воедино',
    fullDescription: 'Профессиональная интеграция облачных сервисов с вашей CRM. Битрикс24, amoCRM, 1С — автоматизируем процессы и устраняем ручной ввод данных.',
    category: 'integration',
    tags: ['Битрикс', 'amoCRM', '1С'],
    icon: 'Link',
    features: [
      'Интеграция за 1-3 дня',
      'Двусторонняя синхронизация',
      'Автоматическое создание сделок',
      'Отчёты в CRM',
      'Техническая поддержка'
    ],
    situations: ['crm-deals', 'integrate-channels'],
    price: 'от 139 500 ₽'
  }
];

export const situations = [
  {
    id: 'crm-deals',
    name: 'Увеличить количество сделок в CRM',
    icon: 'TrendingUp',
    description: 'Решения для роста конверсии и автоматизации воронки продаж'
  },
  {
    id: 'call-control',
    name: 'Улучшить контроль звонков',
    icon: 'PhoneCall',
    description: 'Инструменты мониторинга и аналитики телефонных разговоров'
  },
  {
    id: 'integrate-channels',
    name: 'Интегрировать каналы общения',
    icon: 'Share2',
    description: 'Объединение всех каналов коммуникации в единую систему'
  },
  {
    id: 'support-workload',
    name: 'Снизить нагрузку на техподдержку',
    icon: 'HeadphonesIcon',
    description: 'Автоматизация ответов и AI-помощники для операторов'
  }
];

export const categories = [
  { id: 'all', name: 'Все решения' },
  { id: 'communications', name: 'Коммуникации' },
  { id: 'omnichannel', name: 'Омниканальность' },
  { id: 'ai', name: 'AI-решения' },
  { id: 'analytics', name: 'Аналитика' },
  { id: 'integration', name: 'Интеграции' }
];

export const mockChatResponses = {
  greetings: [
    'Здравствуйте! Я AI-консультант Антологии. Расскажите, какую бизнес-задачу вы хотите решить?',
    'Добро пожаловать! Чем могу помочь? Опишите вашу ситуацию, и я подберу подходящее решение.'
  ],
  crm: [
    'Для увеличения сделок в CRM рекомендую обратить внимание на наши решения: Облачная телефония с интеграцией CRM и AI-агент для квалификации лидов. Хотите узнать подробнее о каком-то из них?',
    'Отличный вопрос! Для роста продаж советую связку: Телефония + Речевая аналитика. Это поможет контролировать качество звонков и улучшить конверсию. Рассказать подробнее?'
  ],
  telephony: [
    'Облачная телефония от Антологии — это виртуальная АТС с интеграцией в CRM за 1 день. Номера в 80+ регионах, запись звонков, аналитика. Стоимость от 990₽/мес. Хотите оставить заявку на демо?',
    'Наша телефония поддерживает интеграцию с Битрикс24, amoCRM, 1С. Все звонки записываются и доступны в карточке клиента. Могу подробнее рассказать о тарифах.'
  ],
  ai: [
    'AI-решения Антологии включают: AI-агент (обработка 80% типовых запросов), Речевая аналитика (контроль качества звонков), База знаний (AI-поиск по документам). Что интересует больше?',
    'Наш AI-агент работает 24/7, обрабатывает типовые вопросы и передаёт сложные кейсы операторам. Окупается за 2-3 месяца за счёт экономии на ФОТ. Хотите расчёт для вашей компании?'
  ],
  support: [
    'Для снижения нагрузки на техподдержку рекомендую: AI-агент + База знаний. AI отвечает на типовые вопросы, а база знаний помогает операторам быстро находить информацию. Эффект — снижение нагрузки до 60%.',
    'Омниканальная платформа + AI-агент — мощная связка для техподдержки. Все обращения в одном окне, AI обрабатывает простые запросы. Хотите узнать стоимость?'
  ],
  default: [
    'Интересный вопрос! Давайте разберёмся подробнее. Какой у вас сейчас размер компании и сколько сотрудников работает с клиентами?',
    'Хороший вопрос. Чтобы подобрать оптимальное решение, расскажите: какие системы вы сейчас используете (CRM, телефония, мессенджеры)?',
    'Понял вас. У нас есть несколько решений, которые могут помочь. Могу показать демо или рассчитать стоимость для вашего случая. Что предпочтительнее?'
  ]
};

export const companyInfo = {
  name: 'Антология',
  tagline: 'IT-решения для бизнеса',
  description: 'Антология — консультант, разработчик и интегратор. Профессионал в реализации проектов с искусственным интеллектом. Настройке частных и публичных облаков, внедрении программного и аппаратного обеспечения. Работа ведётся с вендорами по всему миру. Оплата в рублях со счёта вашей компании. Предоставляем полный пакет закрывающих документов.',
  features: [
    'Поставка тиражируемого ПО на аккаунте клиента',
    'Решения на базе искусственного интеллекта',
    'Интеграция и поддержка решений',
    'Техническая поддержка по SLA'
  ],
  clients: [
    {
      name: 'Ленкабель',
      logo: '/images/logos/lenkabel.png',
    },
    {
      name: 'Pragmatica',
      logo: '/images/logos/pragmatica.svg',
    },
    { 
      name: 'Газпромбанк', 
      logo: 'https://cdn.prod.website-files.com/68c02b25d4a21135bd0bf60a/68fb6887f825b17a15ab1851_logo_sber.png' 
    },
    { 
      name: 'Норникель', 
      logo: 'https://cdn.prod.website-files.com/68c02b25d4a21135bd0bf60a/690123a9e3fe32bf7ac97367_NORNICKEL_logoblock_main_rus.gif' 
    },
    { 
      name: 'ОМК', 
      logo: 'https://cdn.prod.website-files.com/68c02b25d4a21135bd0bf60a/690124a595023eb84f9089a6_ozon.png' 
    },
    { 
      name: 'VK', 
      logo: 'https://cdn.prod.website-files.com/68c02b25d4a21135bd0bf60a/690122a0f5849175ac84eb64_VK_Compact_Logo_(2021-present).svg.png' 
    },
    {
      name: 'Яндекс',
      logo: '/images/logos/yandex.svg',
    },
  ],
  contact: {
    phone: '+7-921-888-63-63',
    email: 'hi@antologia.tech',
    calendly: 'https://calendly.com/uspenskiisergei/one-on-one',
    workingHours: 'Пн-Пт: 10:00 - 19:00 МСК'
  }
};
